import { Form, Head } from '@inertiajs/react'
import Heading from '@/components/heading'
import InputError from '@/components/input-error'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Spinner } from '@/components/ui/spinner'
import AppLayout from '@/layouts/app-layout'
import { serversPath, newServerPath } from '@/routes'
import type { BreadcrumbItem } from '@/types'

const breadcrumbs: BreadcrumbItem[] = [
  { title: 'Servers', href: serversPath() },
  { title: 'New Server', href: newServerPath() },
]

export default function ServersNew() {
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="New Server" />

      <div className="p-6">
        <Heading
        title="Add Server"
        description="Create a new server to manage"
      />

      <Card className="mt-6 max-w-2xl">
        <CardHeader>
          <CardTitle>Server Details</CardTitle>
          <CardDescription>
            Enter the basic information about your server
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Form
            method="post"
            action={serversPath()}
            className="space-y-6"
          >
            {({ processing, errors }) => (
              <>
                <div className="grid gap-2">
                  <Label htmlFor="name">Name *</Label>
                  <Input
                    id="name"
                    name="server[name]"
                    type="text"
                    required
                    autoFocus
                    placeholder="Production Server"
                  />
                  <InputError messages={errors['server.name']} />
                </div>

                <div className="grid gap-2">
                  <Label htmlFor="hostname">Hostname</Label>
                  <Input
                    id="hostname"
                    name="server[hostname]"
                    type="text"
                    placeholder="server.example.com"
                  />
                  <InputError messages={errors['server.hostname']} />
                </div>

                <div className="grid gap-2">
                  <Label htmlFor="info">Info (Markdown)</Label>
                  <textarea
                    id="info"
                    name="server[info]"
                    rows={5}
                    className="flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                    placeholder="Server notes and documentation..."
                  />
                  <InputError messages={errors['server.info']} />
                </div>

                <div className="flex justify-end gap-4">
                  <Button type="button" variant="outline" onClick={() => history.back()}>
                    Cancel
                  </Button>
                  <Button type="submit" disabled={processing}>
                    {processing && <Spinner />}
                    Create Server
                  </Button>
                </div>
              </>
            )}
          </Form>
        </CardContent>
      </Card>
      </div>
    </AppLayout>
  )
}
